import { computed } from 'vue';

export function useFieldErrors(errors, errorName) {
  const errorsSource = computed(() => {
    if (errors) {
      return errors;
    }

    return undefined;
  });

  const hasError = computed(() => {
    if (!errorsSource.value) {
      return false;
    }

    return errorsSource.value.has(errorName);
  });

  const errorMessages = computed(() => {
    if (!hasError.value) {
      return [];
    }

    return errorsSource.value.get(errorName);
  });

  return { hasError, errorMessages, errorsSource };
}
